import Grid from "@material-ui/core/Grid/index";
import Container from "@material-ui/core/Container/index";
import React from "react";
import GetStartedMobileAppDownloadWidget from './GetStartedMobileAppDownloadWidget';
import GetStartedDesktopAppDownloadWidget from './GetStartedDesktopAppDownloadWidget';
import GetStartedConnectWidget from './GetStartedConnectWidget';


class GetStartedBodyWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {appStyle} = this.props;
        return (
            <Container maxWidth="md" component="main">
                <Grid container spacing={2} alignContent="center">
                    <GetStartedMobileAppDownloadWidget appStyle={appStyle} />
                    <GetStartedDesktopAppDownloadWidget appStyle={appStyle} />
                    <GetStartedConnectWidget appStyle={appStyle} />
                </Grid>
            </Container>
        );
    }
}

export default GetStartedBodyWidget;